export default ({ invitedUsers = [], userId = 0, canRsvp = false }) =>
  canRsvp &&
  invitedUsers.includes(
    invitedUsers.find(invitee => invitee.userId === userId),
  );
